export const SCRIPTS_CONSTANTS = {
    thirdPartyScripts: [
      // {
      //   // 'Add script name here'
      //   scriptType: null,
      //   scriptText: `Add script here`
    	// },
      //
      // for non region specific scriptText is a string
      // scriptText: ``
      //
      // region specific scripts
      // add the region to the scriptText
      {
        // Survicate script with au uk region
        scriptType: 'text/javascript',
        scriptText: {
          au: `(function (w) {var s = document.createElement("script");s.src = "https://survey.survicate.com/workspaces/5f07077424584893221917c4ac898d2c/web_surveys.js";s.async = true;var e = document.getElementsByTagName("script")[0];e.parentNode.insertBefore(s, e);})(window);`,
          uk: `(function (w) {var s = document.createElement("script");s.src = "https://survey.survicate.com/workspaces/d257358d71ab75ac0446f6795c391b92/web_surveys.js";s.async = true;var e = document.getElementsByTagName("script")[0];e.parentNode.insertBefore(s, e);})(window);`
        }
      }
    ],
    customerIO: {
      type: 'text/javascript',
      text: `
        var _cio = _cio || [];
        (function() {
            var a,b,c;a=function(f){return function(){_cio.push([f].
            concat(Array.prototype.slice.call(arguments,0)))}};b=["load","identify",
            "sidentify","track","page","on","off"];for(c=0;c<b.length;c++){_cio[b[c]]=a(b[c])};
            var t = document.createElement('script'),
                s = document.getElementsByTagName('script')[0];
            t.async = true;
            t.id    = 'cio-tracker';
            t.setAttribute('data-site-id', '{{ cio_data_site_id }}');
            t.setAttribute('data-use-array-params', 'true');
            t.setAttribute('data-use-in-app', 'true');
            t.src = 'https://assets.customer.io/assets/track.js';
            //If your account is in the EU, use:
            //t.src = 'https://assets.customer.io/assets/track-eu.js'
            s.parentNode.insertBefore(t, s);
        })();

        _cio.identify({
          // Required attributes — you must include your customer's identifier (this can be either an email address or a unique ID value) in a property named "id". See below for more details.
          id: '{{ cio_id }}',
        });
      `
    }
  };
